<template>
    <div class="modal-body-detail-row d-flex">
        <app-label-text class="mb-0" :title="title"></app-label-text>
        <app-normal-text :text="text"></app-normal-text>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            text: String
        }
    }
</script>

<style lang="sass" scoped>
    label
        min-width: 100px
    .modal-body-detail-row
        padding: 12px 0
        border-bottom: solid 1px rgba(0, 0, 0, 0.08)
</style>